import React, { useState, useRef, useEffect } from "react";
import localize from "../../../../../../../core/utils/translation-files";
import TextArea from "antd/lib/input/TextArea";
import RenderSvg from "../../../../../../../layout/components/icons/RenderSvg";
import LookupDropDown from "../../../../../../../layout/components/select/LookupDropDown";
import isEmpty from "../../../../../../../core/helpers/isEmpty";
export const Formula = ({ values, setFieldValue, handleBlur, handleChange, errors, touched, isSystemCreated, customError, setCustomError, validateFormula, componentOptions, }) => {
    const [isEditable, setIsEditable] = useState(false);
    const [selectedApiId, setSelectedApiId] = useState(null);
    const textAreaRef = useRef(null);
    useEffect(() => {
        const context = document.createElement("canvas").getContext("2d");
        if (!context)
            return;
        context.font = "14px Arial";
        const maxTextWidth = Math.max(...componentOptions.map((item) => context.measureText(`${item.id} - ${item.name}`).width));
        const width = Math.min(Math.ceil(maxTextWidth + 3), window.innerWidth * 0.9);
        const styleContent = `
      .formula-dropdown {
        min-width: ${width}px !important;
        max-width: 90vw !important;
        white-space: nowrap !important;
        overflow-x: auto !important;
      }
      .formula-dropdown .ant-select-item-option-content {
        white-space: nowrap !important;
      }
    `;
        let style = document.getElementById("custom-ant-dropdown-style");
        if (!style) {
            style = document.createElement("style");
            style.id = "custom-ant-dropdown-style";
            document.head.appendChild(style);
        }
        style.innerHTML = styleContent;
    }, [componentOptions]);
    const handleDropdownChange = (name, value) => {
        var _a, _b;
        if (!isEditable)
            return;
        const textArea = (_b = (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea;
        if (!textArea)
            return;
        const insert = `_r_${value}`;
        const { selectionStart, selectionEnd } = textArea;
        const formula = values.formula || "";
        const updated = formula.slice(0, selectionStart) + insert + formula.slice(selectionEnd);
        setFieldValue("formula", updated);
        setSelectedApiId(value);
        setTimeout(() => {
            textArea.focus();
            const pos = selectionStart + insert.length;
            textArea.setSelectionRange(pos, pos);
        }, 100);
        setTimeout(() => {
            setSelectedApiId(null);
        }, 100);
    };
    const handleBlurWithDropdownCheck = (e) => {
        handleBlur(e);
        setTimeout(() => {
            if (!isSystemCreated) {
                validateFormula(e.target.value);
            }
        }, 150);
    };
    return (React.createElement("div", { className: "box-main-section", hidden: isSystemCreated },
        React.createElement("section", { className: "box-section" },
            React.createElement("div", { className: "box-title" },
                React.createElement("div", { className: "box-heading" }, localize(["TrackedItem.formula"]))),
            React.createElement("div", { className: "box-description" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-3 col-md-4 col-sm-6" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement("div", { className: "ant-col bold-text" },
                                React.createElement("label", null, localize(["TrackedItem.component"]))),
                            React.createElement(LookupDropDown, { className: "mb-2 mb-md-0", inputName: "apiIdDropdown", valueType: "string", selectedValue: selectedApiId, onChange: handleDropdownChange, localizationKey: ["TrackedItem.component"], options: componentOptions.map((item) => ({
                                    code: item.id,
                                    text: `${item.id} - ${item.name}`,
                                })), textProperty: "text", valueProperty: "code", error: null, dropdownClassName: "formula-dropdown" }))),
                    React.createElement("div", { className: "col-lg-6 col-md-8 col-sm-12" },
                        React.createElement("div", { className: "form-group" },
                            React.createElement("div", { className: "ant-col bold-text", style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                } },
                                React.createElement("label", null, localize(["TrackedItem.formula"])),
                                !isEditable && (React.createElement(RenderSvg, { icon: "Edit", onClick: () => {
                                        setIsEditable(true);
                                        setTimeout(() => {
                                            var _a, _b;
                                            const textArea = (_b = (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea;
                                            if (textArea) {
                                                textArea.focus();
                                                const length = textArea.value.length;
                                                textArea.setSelectionRange(length, length);
                                            }
                                        }, 0);
                                    }, style: {
                                        position: "absolute",
                                        right: 5,
                                        top: 23,
                                        zIndex: 1,
                                        cursor: "pointer",
                                    } }))),
                            React.createElement(TextArea, { ref: textAreaRef, name: "formula", placeholder: localize(["TrackedItem.formula"]), onBlur: handleBlurWithDropdownCheck, autoSize: { minRows: 2, maxRows: 3 }, onChange: (e) => {
                                    handleChange(e);
                                    !isEmpty(customError === null || customError === void 0 ? void 0 : customError.formula) &&
                                        setCustomError(Object.assign(Object.assign({}, customError), { formula: undefined }));
                                }, value: values.formula, disabled: !isEditable, style: { backgroundColor: isEditable ? "#fff" : "#f2f2f2" }, className: `formula-textarea ${((!isEmpty(customError === null || customError === void 0 ? void 0 : customError.formula) &&
                                    (customError === null || customError === void 0 ? void 0 : customError.formula) !== "") ||
                                    errors.formula) &&
                                    touched.formula
                                    ? "input-error"
                                    : ""} ${!isEditable ? "readonly-mode" : ""}` }),
                            ((!isEmpty(customError === null || customError === void 0 ? void 0 : customError.formula) &&
                                (customError === null || customError === void 0 ? void 0 : customError.formula) !== "") ||
                                errors.formula) &&
                                touched.formula && (React.createElement("p", { className: "error" }, errors.formula || (customError === null || customError === void 0 ? void 0 : customError.formula))))))))));
};
export default Formula;
